/**
 * Utilidades para manejo de texto y validación
 */
class TextUtils {
    
    /**
     * Validar si un título es válido
     */
    static isValidTitle(title) {
        if (!title || title.length < 3 || title.length > 60) {
            return false;
        }
        
        // ✅ PATRONES PROBLEMÁTICOS UNIVERSALES
        const problematicPatterns = [
            /N\/A\s*\/\s*\w+/,              // N/A / algo
            /TRAILER\s*\/\s*TRAILER/,        // TRAILER / TRAILER
            /^[A-Z]{2,3}-\d+-[A-Z]+$/,       // Códigos tipo YZJ-123-ABC
            /^CAM\d+$/,                      // CAM123
            /^CHE\d+$/,                      // CHE123
            /^AUDITORIA\s*\d+$/,             // AUDITORIA 123
            /^\d+$/,                         // Solo números
            /^[^a-zA-Z]*$/,                  // Sin letras
            /undefined|null|NaN/i            // Valores inválidos
        ];
        
        return !problematicPatterns.some(pattern => pattern.test(title));
    }

    /**
     * Validar título específico para recorridos
     */
    static isValidRecorridosTitle(title) {
        if (!title || title.length < 3 || title.length > 60) {
            return false;
        }
        
        // ✅ PERMITIR TÍTULOS ESPECÍFICOS DE RECORRIDOS
        const validRecorridosTitles = [
            'mapa', 'velocidad', 'kilometraje', 'visitas', 'recorridos', 
            'listado', 'gráfico', 'análisis', 'frecuentes'
        ];
        
        const titleLower = title.toLowerCase();
        const hasValidKeyword = validRecorridosTitles.some(keyword => 
            titleLower.includes(keyword)
        );
        
        if (hasValidKeyword) {
            return true;
        }
        
        // ✅ PATRONES PROBLEMÁTICOS ESPECÍFICOS
        const problematicPatterns = [
            /^[A-Z]{2,3}-\d+-[A-Z]+$/,       // Códigos de vehículo
            /^CAM\d+$/,                      // CAM123
            /^CHE\d+$/,                      // CHE123
            /^\d+$/,                         // Solo números
            /^[^a-zA-Z]*$/,                  // Sin letras
            /undefined|null|NaN/i            // Valores inválidos
        ];
        
        return !problematicPatterns.some(pattern => pattern.test(title));
    }

    /**
     * Truncar texto según ancho en PDF
     */
    static truncateText(pdf, text, maxWidth) {
        if (!text || text.toString().trim() === '') {
            return '';
        }
        
        const textStr = text.toString().trim();
        const textWidth = pdf.getTextWidth(textStr);
        
        if (textWidth <= maxWidth) {
            return textStr;
        }
        
        // ✅ MEJORAR TRUNCADO - más eficiente
        let truncated = textStr;
        const ellipsis = '...';
        const ellipsisWidth = pdf.getTextWidth(ellipsis);
        
        // Encontrar longitud máxima que quepa
        while (truncated.length > 0 && pdf.getTextWidth(truncated) + ellipsisWidth > maxWidth) {
            truncated = truncated.slice(0, -1);
        }
        
        return truncated.length < textStr.length ? truncated + ellipsis : textStr;
    }

    /**
     * Limpiar texto de celda de tabla
     */
    static cleanCellText(text) {
        if (!text) return '';
        
        // Limpiar caracteres especiales y espacios extra
        return text.replace(/[\n\r\t]/g, ' ')
                  .replace(/\s+/g, ' ')
                  .trim();
    }

    /**
     * Generar nombre de archivo con timestamp
     */
    static generateFileName(prefix = 'reporte', suffix = 'pdf') {
        const timestamp = new Date().getTime();
        const date = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
        return `${prefix}-${date}-${timestamp}.${suffix}`;
    }

    /**
     * Formatear tamaño de archivo
     */
    static formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    /**
     * Validar configuración de impresión
     */
    static validatePrintConfig(config) {
        const errors = [];
        
        if (!config.title || config.title.trim().length === 0) {
            errors.push('El título del reporte es obligatorio');
        }
        
        if (!config.includeCharts && !config.includeTable) {
            errors.push('Debe seleccionar al menos un tipo de contenido');
        }
        
        if (config.orientation && !['landscape', 'portrait'].includes(config.orientation)) {
            errors.push('Orientación inválida');
        }
        
        return {
            isValid: errors.length === 0,
            errors
        };
    }
}

export default TextUtils;